<div class="blocking-progress-dialog">
  <h2 mat-dialog-title class="dialog-title">
    <span class="title-left">
      <span class="icon" *ngIf="data?.icon">
        <i [class]="data.icon"></i>
      </span>
      <span class="text">{{ title }}</span>
    </span>
  </h2>

  <div mat-dialog-content class="dialog-content">
    <p class="message mb-0">{{ message }}</p>

    <div class="spinner-row">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="40"
        strokeWidth="4"
      ></mat-progress-spinner>
    </div>
  </div>
</div>

